import { useState, useEffect, useCallback } from 'react';

export const useAutoRefresh = (refreshFn, interval = 30000) => {
    const [isEnabled, setIsEnabled] = useState(true);
    const [lastRefresh, setLastRefresh] = useState(Date.now());

    const manualRefresh = useCallback(() => {
        if (refreshFn) {
            refreshFn();
            setLastRefresh(Date.now());
        }
    }, [refreshFn]);

    useEffect(() => {
        if (!isEnabled || !refreshFn) return;

        const intervalId = setInterval(() => {
            refreshFn();
            setLastRefresh(Date.now());
        }, interval);

        return () => clearInterval(intervalId);
    }, [refreshFn, interval, isEnabled]);

    return {
        isEnabled,
        setIsEnabled,
        manualRefresh,
        lastRefresh
    };
};